import React, { Component } from 'react'
import PrimaryTitle from '../components/PrimaryTitle'
import history from '../service/history.service'
import { Button } from 'react-bootstrap'
import PropTypes from 'prop-types'
import withRouter from '../components/withRouter'
import t from '../service/translate.service'

class ServerErrorPage extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props)
  }
  goBack = (e) => {
    e.preventDefault()
    this.props.navigate(-2)
  }

  render() {
    const error = this.props.location.state
    return (
      <div className="thank-you-overlay">
        <div className="wrapper">
          <h1>{error.name}</h1>
          <p className="description">
            {localStorage.getItem("locale") === "de" ? error.message : "Anfrage fehlgeschlagen mit Statuscode 500"}
          </p>
          <Button 
            className="button primary" 
            onClick={this.goBack} 
            aria-label={t.GOBACK}
          >
            OK
          </Button>
        </div>
      </div>
    );
  }
}

export default (withRouter(ServerErrorPage))
